import Types from "../../constants/Types.js";
import DeviceGroupDelegate from "../../delegates/device/DeviceGroupDelegate.js";
import { ImagineGroup } from "../builders/index.js";
export default ImagineGroup({
  objectType: Types.device,
  delegate: DeviceGroupDelegate,
  relationshipPath: 'leverege.fotaApi.device'
});